import { FONT_SIZE_BASE } from '../theme/constants';
export const getGlobalFontRatio = (defaultFontSize = FONT_SIZE_BASE) => {
    const fontSizeStr = window && (document === null || document === void 0 ? void 0 : document.body)
        ? window.getComputedStyle(document.body).getPropertyValue('font-size')
        : `${defaultFontSize}px`;
    const match = fontSizeStr.match(/\d+/u);
    const fontSize = (match === null || match === void 0 ? void 0 : match.length) ? Number(match[0]) : defaultFontSize;
    return fontSize / defaultFontSize;
};
//# sourceMappingURL=getGlobalFontRatio.js.map